module.exports = __webpack_public_path__ + "img/dark-logo-back.318b5b84.jpg";